import { Helmet } from "react-helmet";
import CareerHero from "../home/CareerHero";
import CareerWhy from "../home/CareerWhy";
import CareerLife from "../home/CareerLife";
import CareerPositions from "../home/CareerPositions";

export default function Career() {
  return (
    <>
      <Helmet>
        <title>GPS Finvest - Careers</title>
        <meta
          name="description"
          content="Join GPS Finvest and build a rewarding career in the financial services industry. Explore job opportunities, internships, and grow with us."
        />
      </Helmet>

      <CareerHero />
      <CareerWhy />
      <CareerLife />
      <CareerPositions />
    </>
  );
}
